import { useState, useCallback } from 'react'
import { FormikHelpers } from 'formik'
import { useRunAfterRequestFinishes } from '@ocean/hooks'

type useFormikBagProps<FormDataParams> = {
  onSubmit: (formData: FormDataParams) => void
  isLoading?: boolean
}

type useFormikBagData<FormDataParams> = {
  handleSubmit: (formData: FormDataParams, actions: FormikHelpers<FormDataParams>) => void
  formikBag: FormikHelpers<FormDataParams> | null
}

const useFormikBag = <FormDataParams>(
  props: useFormikBagProps<FormDataParams>
): useFormikBagData<FormDataParams> => {
  const { onSubmit, isLoading } = props
  const [formikBag, setFormikBag] = useState<FormikHelpers<FormDataParams> | null>(null)

  useRunAfterRequestFinishes({
    isLoading,
    action: () => formikBag && formikBag.setSubmitting(false),
    runCondition: !!formikBag,
  })

  const handleSubmit = useCallback(
    (formData: FormDataParams, actions: FormikHelpers<FormDataParams>) => {
      setFormikBag(actions)
      onSubmit(formData)
    },
    [onSubmit]
  )

  return { handleSubmit, formikBag }
}

export default useFormikBag
